<template>
  <div>
    <div style="position: relative">
      <img
        :src="aboutUs.picture"
        :width="imgwidth + 'px'"
        :height="imgHeight + 'px'"
        class="img_index"
      />
      <img class="img0" :src="aboutUs.titlePicture" :width="img0width + 'px'" />
      <h1 class="h1_title h_shadow">{{ aboutUs.title }}</h1>
      <h3 class="h2_title h_shadow">{{ aboutUs.titleContent }}</h3>
    </div>

    <div class="margin_top">
      <el-image
        :src="aboutUs.companyBackground"
        style="width: 1200px; height: 340px; z-index: -1"
      />
      <div style="margin: -260px 50px 0; height: 260px">
        <h2 style="margin-top: 0">公司简介</h2>
        <div class="text_content">
          <div v-for="(content, index) in aboutUs.companyContent" :key="index">
            {{ content }}
          </div>
        </div>
      </div>
    </div>
    <div class="margin_top">
      <el-image
        :src="aboutUs.companyBackground"
        style="width: 1200px; height: 340px; z-index: -1"
      />
      <div style="margin: -250px 50px 0; height: 250px">
        <h2 style="margin-top: 0">企业文化</h2>
        <div class="text_content">
          <div
            v-for="(content, index) in aboutUs.companyContentCulture"
            :key="index"
          >
            {{ content }}
          </div>
        </div>
      </div>
    </div>

    <div class="margin_top">
      <el-image
        :src="aboutUs.companyPicture"
        style="width: 1200px; height: 500px"
      />
    </div>
    <div class="message_wrapper">
      <div class="message_title">留言反馈</div>
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司名称" prop="company">
              <el-input v-model="form.company" class="custom-input"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="需求行业" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="from_name">
              <el-input v-model="form.from_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="phone">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="需求描述" prop="content">
              <el-input
                type="textarea"
                :rows="4"
                v-model="form.content"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label-width="0">
          <el-button type="info" class="sub_btn" @click="onSubmit"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";
export default {
  name: "AboutUs",
  data() {
    return {
      aboutUs: global.aboutUs,
      imgHeight: 525,
      imgwidth: 0,
      img0width: 868,
      form: {
        company: "",
        from_name: "",
        phone: "",
        content: "",
        name: "", // 需求行业
      },
      rules: {
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        content: [
          { required: true, message: "请输入需求描述", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    this.imgwidth = window.innerWidth;
    this.handleResize();
  },
  destroyed() {
    // 移除窗口大小变化事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.imgwidth = window.innerWidth;
  },
  methods: {
    // 窗口大小变化时更新页面宽度值
    handleResize() {
      this.imgHeight = window.innerWidth / 3;
      this.imgwidth = window.innerWidth;
      this.img0width = (window.innerWidth * 52) / 100;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "发送中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          // https://dashboard.emailjs.com
          emailjs
            .send(
              "service_iiqf69x",
              "template_7awe2tq",
              this.form,
              "BSMrMpgMuhRNnfgWc"
            )
            .then(
              (result) => {
                console.log("SUCCESS!", result.status, result.text);
                loading.close();
                this.$message({ message: "留言成功", type: "success" });
                this.$refs.form.resetFields();
              },
              (error) => {
                console.log("FAILED...", error);
                loading.close();
                this.$message({ message: "留言失败", type: "error" });
              }
            );
        }
      });
    },
  },
};
</script>

<style scoped>
.h_shadow {
  box-shadow: -2px 5px 7px 0 rgba(0, 0, 0, 0.5);
}

.h1_title {
  position: absolute;
  top: 47%;
  left: 35%;
  width: 440px;
  color: #ffeb3b;
  text-shadow: 2px 5px 5px rgba(0, 0, 0, 0.5);
  font-size: 2.5em;
}

.h2_title {
  position: absolute;
  top: 80%;
  right: 20%;
  width: 604px;
  color: #2a82e4;
  background-color: #ffffff;
  float: right;
  font-size: 1.3em;
}

.img0 {
  position: absolute;
  top: 1%;
  left: 20%;
}

.text_content {
  text-align: left;
  text-indent: 2em;
  line-height: 28px;
  padding: 0 100px;
  font-size: 18px;
}

.img_index {
  display: inline-block;
}

.message_wrapper {
  width: 1000px;
  background: #f5f4f4;
  margin: 0 auto;
  border-radius: 38px;
  padding: 15px;
}

.message_title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 18px;
}

.sub_btn {
  background: #2b2b2b;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/aboutUs.vue